/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type ClockWidgetContainer_widget$ref: FragmentReference;
declare export opaque type ClockWidgetContainer_widget$fragmentType: ClockWidgetContainer_widget$ref;
export type ClockWidgetContainer_widget = {|
  +id: string,
  +name: ?string,
  +enabled: ?boolean,
  +config: ?string,
  +settings: ?string,
  +type: ?string,
  +$refType: ClockWidgetContainer_widget$ref,
|};
export type ClockWidgetContainer_widget$data = ClockWidgetContainer_widget;
export type ClockWidgetContainer_widget$key = {
  +$data?: ClockWidgetContainer_widget$data,
  +$fragmentRefs: ClockWidgetContainer_widget$ref,
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "ClockWidgetContainer_widget",
  "type": "Widget",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "id",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "name",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "enabled",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "config",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "settings",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "type",
      "args": null,
      "storageKey": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '4b0423624c7b83a6515ee712c6554bef';
module.exports = node;
